module.exports = "";


//////////////////
// WEBPACK FOOTER
// ./src/tmplate/innerHTML.html
// module id = 137
// module chunks = 0